import { FaBell, FaEuroSign, FaUsers } from "react-icons/fa6";
import { BsArrowsMove } from "react-icons/bs";
import dashboard from "../assets/dashboard.png";
import barazimi from "../assets/barazimi.png";
import transaksionet from "../assets/transaksionet.png";
import autoshkollat from "../assets/autoshkollat.png";
import kandidatet from "../assets/kandidatet.png";
import kartelat from "../assets/kartelat.png";
import pakot from "../assets/pakot.png";
import kategorite from "../assets/kategorite.png";
import testet from "../assets/testet.png";
import pyetjet from "../assets/pyetjet.png";
import literatura from "../assets/literatura.png";
import users from "../assets/users.png";
import cash from "../assets/cash.png";

export const data = [
  {
    id: 1,
    name: "Autoshkolla Test ",
    city: "Prishtinë",
    date: "2022-01-01",
    status: "Aktive",
  },
  {
    id: 2,
    name: "Autoshkolla Poligoni",
    city: "Gjilan",
    date: "2022-02-01",
    status: "Pasive",
  },
  {
    id: 3,
    name: "Autoshkolla Instruktori",
    city: "Prishtinë",
    date: "2022-03-01",
    status: "Aktive",
  },
  {
    id: 4,
    name: "Autoshkolla Shoferi",
    city: "Prizren",
    date: "2022-03-01",
    status: "Aktive",
  },
  {
    id: 5,
    name: "Autoshkolla ",
    city: "Pejë",
    date: "2022-03-01",
    status: "Pasive",
  },
  {
    id: 6,
    name: "Autoshkolla Shoferi ",
    city: "Gjakovë",
    date: "2022-03-01",
    status: "Pasive",
  },
  {
    id: 7,
    name: "Autoshkolla Test ",
    city: "Prishtinë",
    date: "2022-03-01",
    status: "Aktive",
  },
  {
    id: 8,
    name: "Autoshkolla Baza ",
    city: "Gjilan",
    date: "2022-03-01",
    status: "Aktive",
  },
];

export const dataCategories = [
  { id: 1, name: "Kategoria A", date: "2022-01-01", status: "Aktive" },
  { id: 2, name: "Kategoria B", date: "2022-02-01", status: "Pasive" },
  { id: 3, name: "Kategoria C", date: "2022-03-01", status: "Aktive" },
  { id: 4, name: "Kategoria D", date: "2022-03-01", status: "Aktive" },
];

export const dataExams = [
  {
    id: 1,
    name: "Testi 1",
    category: "A",
    date: "2022-01-01",
    status: "Aktive",
  },
  {
    id: 2,
    name: "Testi 2",
    category: "B",
    date: "2022-02-01",
    status: "Pasive",
  },
  {
    id: 3,
    name: "Testi 3",
    category: "C",
    date: "2022-03-01",
    status: "Pasive",
  },
  {
    id: 4,
    name: "Testi 4",
    category: "D",
    date: "2022-03-01",
    status: "Pasive",
  },
  {
    id: 5,
    name: "Testi 5",
    category: "A",
    date: "2022-03-01",
    status: "Aktive",
  },
  {
    id: 6,
    name: "Testi 6",
    category: "D",
    date: "2022-03-01",
    status: "Aktive",
  },
];

export const options = [
  { value: "1", label: "Kategoria A" },
  { value: "2", label: "Kategoria B" },
  { value: "3", label: "Kategoria C" },
  { value: "4", label: "Kategoria D" },
];
export const selectedOptions = [
  { value: "1", label: "Testi 1" },
  { value: "2", label: "Testi B" },
  { value: "3", label: "Testi C" },
  { value: "4", label: "Testi D" },
];

export const dataQuestions = [
  {
    id: 1,
    name: "Sinjali në figurë paralajmëron kryqëzim linjash hekurudhore. ",
    category: "B",
    Lloji: "Pyetje pa foto",
    date: "2022-01-01",
    status: "Aktive",
  },
  {
    id: 2,
    name: "Sinjali në figurë kërkon uljen e shpejtësisë vetëm para kthesës së parë.",
    category: "B",
    Lloji: "Pyetje me foto",
    date: "2022-02-01",
    status: "Pasive",
  },
  {
    id: 3,
    name: "Shpejtësia e lëvizjes së mjetit duhet ngadalësuar në rrugë me terren të rrëshqitshëm.",
    category: "B",
    Lloji: "Pyetje me shenja",
    date: "2022-03-01",
    status: "Pasive",
  },
  {
    id: 4,
    name: "Parakalimi në rrugë urbane bëhet duke kaluar shpejtësinë prej 50 km/orë.",
    category: "B",
    Lloji: "Pyetje pa foto",
    date: "2022-03-01",
    status: "Pasive",
  },
  {
    id: 5,
    name: "Parakalimi në rrugë urbane bëhet duke kaluar shpejtësinë prej 50 km/orë.",
    category: "B",
    Lloji: "Pyetje pa foto",
    date: "2022-03-01",
    status: "Aktive",
  },
  {
    id: 6,
    name: "Në mjetet me motor shkak për zhurmat mund të jetë dëmtimi i sistemit të shuarjes së zhurmave.  ",
    category: "B",
    Lloji: "Pyetje pa foto",
    date: "2022-03-01",
    status: "Aktive",
  },
];

export const dataFinancialBalance = [
  {
    id: 1,
    name: "Autoshkolla Test ",
    city: "Prishtine",
    bills: "120 €",
    paid: "Po",
    debt: "-10",
    date: "2023-04-18",
    status: "Aktive",
  },
  {
    id: 2,
    name: "Autoshkolla Poligoni",
    city: "Prishtine",
    bills: "120 € ",
    paid: "Jo",
    debt: "-10",
    date: "2023-07-18",
    status: "Pasive",
  },
  {
    id: 3,
    name: "Autoshkolla Instruktori",
    city: "Prishtine",
    bills: "120 € ",
    paid: "Po",
    debt: "-10",
    date: "2023-03-12",
    status: "Aktive",
  },
  {
    id: 4,
    name: "Autoshkolla Shoferi",
    city: "Prishtine",
    bills: "120 € ",
    paid: "Po",
    debt: "-10",
    date: "2023-11-20",
    status: "Aktive",
  },
  {
    id: 5,
    name: "Autoshkolla ",
    city: "Prishtine",
    bills: "120 € ",
    paid: "Po",
    debt: "-10",
    date: "2023-12-20",
    status: "Pasive",
  },
  {
    id: 6,
    name: "Autoshkolla Shoferi ",
    city: "Prishtine",
    bills: "120 € ",
    paid: "Po",
    debt: "-10",
    date: "2023-02-20",
    status: "Pasive",
  },
];

export const dataCity = [
  {
    label: "PRISHTINA",
    options: [
      { value: "Prishtinë", label: "Prishtinë" },
      { value: "Podujevë", label: "Podujevë" },
      { value: "Drenas", label: "Drenas" },
      { value: "Fushë Kosovë", label: "Fushë Kosovë" },
      { value: "Graçanicë", label: "Graçanicë" },
      { value: "Lipjan", label: "Lipjan" },
      { value: "Obiliq", label: "Obiliq" },
    ],
  },
  {
    label: "MITROVICË",
    options: [
      { value: "Mitrovicë", label: "Mitrovicë" },
      { value: "Vushtrri", label: "Vushtrri" },
      { value: "Skënderaj", label: "Skënderaj" },
      { value: "Zubin Potok", label: "Zubin Potok" },
      { value: "Leposaviq", label: "Leposaviq" },
      { value: "Zveçan", label: "Zveçan" },
    ],
  },
  {
    label: "Ferizaj",
    options: [
      { value: "Ferizaj", label: "Ferizaj" },
      { value: "Shtime", label: "Shtime" },
      { value: "Kaçanik", label: "Kaçanik" },
      { value: "Shtërpcë", label: "Shtërpcë" },
      { value: "Han I Elezit", label: "Han I Elezit" },
    ],
  },
  {
    label: "GJILAN",
    options: [
      { value: "Gjilan", label: "Gjilan" },
      { value: "Viti", label: "Viti" },
      { value: "Kamenicë", label: "Kamenicë" },
      { value: "Kllokot", label: "Kllokot" },
    ],
  },
  {
    label: "PEJE",
    options: [
      { value: "Pejë", label: "Pejë" },
      { value: "Istog", label: "Istog" },
      { value: "Klinë", label: "Klinë" },
      { value: "Deçan", label: "Deçan" },
      { value: "Junik", label: "Junik" },
    ],
  },
  {
    label: "GJAKOVË",
    options: [{ value: "Gjakovë", label: "Gjakovë" }],
  },
  {
    label: "PRIZREN",
    options: [
      { value: "Prizren", label: "Prizren" },
      { value: "Dragash", label: "Dragash" },
      { value: "Suharekë", label: "Suharekë" },
      { value: "Malishevë", label: "Malishevë" },
      { value: "Rahovec", label: "Rahovec" },
    ],
  },
];

export const links = [
  {
    links: [
      {
        name: "dashboard",
        title: "dashboard",
        icon: dashboard,
        isAdmin: ["admin"],
      },
      {
        name: "financialbalance",
        title: "Barazimi",
        // icon: barazimi,
        icon: kandidatet,
        isAdmin: ["admin"],
      },
      {
        name: "transaksionet",
        title: "Transaksionet",
        icon: transaksionet,
        isAdmin: ["admin"],
      },
      {
        name: "drivingschools",
        title: "autoshkollat",
        icon: autoshkollat,
        isAdmin: ["admin"],
      },

      {
        name: "users",
        title: "Kandidatët",
        icon: kandidatet,
        isAdmin: ["admin"],
      },
      {
        name: "cards",
        title: "Kartelat",
        icon: kartelat,
        isAdmin: ["admin"],
      },
      {
        name: "package",
        title: "pakot",
        icon: pakot,
        isAdmin: ["admin"],
      },

      {
        name: "categories",
        title: "kategoritë",
        icon: kategorite,
        isAdmin: ["admin"],
      },
      {
        name: "exams",
        title: "testet",
        icon: testet,
        isAdmin: ["admin"],
      },
      {
        name: "questions",
        title: "pyetjet e testeve",
        icon: pyetjet,
        isAdmin: ["admin"],
      },
      {
        name: "questionscategory",
        title: "pyetjet tek pyetjet",
        icon: pyetjet,
        isAdmin: ["admin"],
      },
      {
        name: "question-category",
        title: "pyetjet",
        icon: pyetjet,
        isAdmin: ["admin"],
      },
      {
        name: "literature",
        title: "Literatura",
        icon: literatura,
        isAdmin: ["admin"],
      },
      {
        name: "textliterature",
        title: "Teksti",
        icon: literatura,
        isAdmin: ["admin"],
      },
      {
        name: "ads",
        title: "Ads",
        icon: <FaEuroSign />,
        isAdmin: ["admin"],
      },
      {
        name: "users-driveschool",
        title: "Kandidatët dhe progresi",
        icon: users,
        isAdmin: ["user"],
      },
      {
        name: "movment",
        title: "Aktivizimi i kandidatëve",
        icon: cash,
        isAdmin: ["user"],
      },
      {
        name: "notifications",
        title: "Njoftimet",
        icon: kategorite,
        isAdmin: ["admin"],
      },
    ],
  },
];
